import React from "react";
import { connect } from "react-redux";
import { Field, FieldArray } from "formik";
import BirthDate from "./BirthDate";
import Name from "./Name";
import "./ParticipantForm.scss";
import { participantsAgeTest, validateName, setOrdinal } from "./validation";
import { currentLocale } from "../locale";
import { gte } from "ramda";
import { NEXT_SELECTED } from "../constants";

const ParticipantList = props => {
    const { field, form, nextSelected, waiver } = props;
    return (
        <div className="participant-list">
            <Field
                className="participant-list"
                name="participantList"
                value={form.values.participants}
                render={() => (
                    <FieldArray
                        name="participants"
                        waiver={waiver}
                        render={arrayHelpers => (
                            <div>
                                <div className="columns is-mobile">
                                    <div className="column">
                                        <h1 className="title is-5">
                                            {waiver.birthday
                                                ? `${currentLocale.imSigning} ${
                                                currentLocale.andBirthday
                                                }`
                                                : `${currentLocale.imSigning}`}
                                        </h1>
                                        <h2 className="title is-6">{currentLocale.oneName}</h2>
                                    </div>
                                </div>

                                {form.values.participants &&
                                    form.values.participants.length > 0 ? (
                                        form.values.participants.map((participant, index) => (
                                            <div key={index} className="columns is-mobile">
                                                <div className="column is-left">
                                                    <Field
                                                        helperText={currentLocale.oneName}
                                                        className="input"
                                                        waiver={waiver}
                                                        validate={validateName}
                                                        name={`participants[${index}].participantName`}
                                                        component={Name}
                                                        index={index}
                                                        placeholder={`${setOrdinal(Number(index) + 1)} ${
                                                            currentLocale.minorNamePlaceHolder
                                                            }`}
                                                        value={
                                                            form.values.participants[index].participantName
                                                        }
                                                    />
                                                </div>

                                                {waiver.birthday ? (
                                                    <div className="column">
                                                        <Field
                                                            className="input"
                                                            validate={participantsAgeTest}
                                                            name={`participants[${index}].participantBirthday`}
                                                            value={
                                                                form.values.participants[index]
                                                                    .participantBirthday
                                                            }
                                                            component={BirthDate}
                                                            placeholder={currentLocale.datePlaceholder}

                                                        />
                                                    </div>
                                                ) : null}

                                                {gte(index, 1) ? (
                                                    <div className="column is-narrow">
                                                        <span className="label" />
                                                        <button
                                                            className="button is-primary"
                                                            type="button"
                                                            onClick={() => arrayHelpers.remove("")}
                                                        >
                                                            <i className="fa fa-trash" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>
                                        ))
                                    ) : (
                                        <div />
                                    )}
                                <div>
                                    <button
                                        className="button is-primary"
                                        type="button"
                                        onClick={() => {
                                            arrayHelpers.push({
                                                participantName: "",
                                                participantBirthday: ""
                                            });
                                            nextSelected();
                                        }}
                                    >
                                        {currentLocale.addMinor}
                                    </button>
                                </div>
                            </div>
                        )}
                    />
                )}
            />
        </div>
    );
};

const mapStateToProps = state => ({
    waiver: state.currentWaiver
});

const mapActionsToProps = dispatch => ({
    nextSelected: () => dispatch({ type: NEXT_SELECTED })
});

const connector = connect(
    mapStateToProps,
    mapActionsToProps
);

export default connector(ParticipantList);
